let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7Kkgk")).then(() => parcelRequire('ix1Mi'));